// Search bundle — included only on search/featured_profiles pages.
// Keeps Algolia + react-instantsearch out of the main bundle.
import React from 'react';
import { createRoot } from 'react-dom/client';
import SearchContainer from './components/Search/SearchContainer';
import ConsultantSearchCard from './components/Search/ConsultantSearchCard';
import SearchFilterMenu from './components/Search/SearchFilterMenu';
import FeaturedProfiles from './components/FeaturedProfiles';
import FeaturedProfilesCarousel from './components/FeaturedProfilesCarousel';
import AlgoliaInstantSearch from './components/FeaturedProfiles/AlgoliaInstantSearch';
import ProjectSearchContainer from './components/ProjectSearchContainer';
import ConsultantSearchContainer from './components/ConsultantSearchContainer';
var components = {
  SearchContainer: SearchContainer,
  ConsultantSearchCard: ConsultantSearchCard,
  SearchFilterMenu: SearchFilterMenu,
  FeaturedProfiles: FeaturedProfiles,
  FeaturedProfilesCarousel: FeaturedProfilesCarousel,
  AlgoliaInstantSearch: AlgoliaInstantSearch,
  ProjectSearchContainer: ProjectSearchContainer,
  ConsultantSearchContainer: ConsultantSearchContainer
};
var mountedRoots = new WeakMap();
function mountSearchComponents() {
  document.querySelectorAll('[data-react-component]').forEach(function (node) {
    var componentName = node.dataset.reactComponent;
    var Component = components[componentName];
    if (!Component) return;
    try {
      var props = JSON.parse(node.dataset.reactProps || '{}');
      var root = mountedRoots.get(node);
      if (!root) {
        root = createRoot(node);
        mountedRoots.set(node, root);
      }
      root.render(/*#__PURE__*/React.createElement(Component, props));
    } catch (error) {
      console.error("Error mounting component ".concat(componentName, ":"), error);
    }
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountSearchComponents);
} else {
  mountSearchComponents();
}
document.addEventListener('turbo:load', mountSearchComponents);
document.addEventListener('turbo:render', mountSearchComponents);